<template>
  <div class="home-view">
    <section class="-content">
      <div class="container">
        <h1 class="title-default">Guia Financeiro <span>Aqui ficam as mensagens importantes que a /Vibra manda para você!</span></h1>

        <div class="iframe">
          <article v-html="data.conteudo"></article>

          <!-- <iframe></iframe> -->
        </div>
      </div> <!-- /.container -->
    </section> <!-- /.-content -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'guia-financeiro',

  data () {
    const data = {
      data: {}
    }

    return data
  }, // data()

  beforeMount () {
    this.load()
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async load () {
      try {
        let xhr = await PagesService.getGuia()

        this.data = xhr
      } catch (e) {
        console.error('Falha ao carregar o conteúdo HTML', e)
      }
    } // load()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'
</style>
